import { render, staticRenderFns } from "./WarrantSummary.vue?vue&type=template&id=ddbc1966&scoped=true"
import script from "./WarrantSummary.vue?vue&type=script&lang=js"
export * from "./WarrantSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbc1966",
  null
  
)

export default component.exports